import React from 'react';
import ProducerDetail from "../components/ProducerDetail";


const ProducersPage = () => {
    return (
        <React.Fragment>
            <ProducerDetail />
        </React.Fragment>
    );
};

export default ProducersPage;

